import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_LIGHTER} from 'ui-library/Colors';
import Link from 'ui-library/Link';

import {CollapsibleTriangle} from './TriangleToggle';

export interface LogContainerProps {
  children: React.ReactNode;
  header?: string;
  backgroundColor?: string;
  collapsible?: boolean;
}

const DEFAULT_BACKGROUND_COLOR = GRAY_LIGHTER;

/**
 * A simple box for rendering messages.
 */
export default function LogContainer(props: LogContainerProps): JSX.Element {
  const collapsible = props.collapsible ?? false;
  const [isCollapsed, setIsCollapsed] = useState(collapsible);

  return (
    <div
      className={classNames(css(styles.logContainer))}
      style={{backgroundColor: props.backgroundColor ? props.backgroundColor : DEFAULT_BACKGROUND_COLOR}}
    >
      {(props.header || collapsible) && (
        <div
          className={classNames(css(styles.header))}
          {...getTestProps({component: 'LogContainer', element: 'header'})}
          onClick={() => {
            setIsCollapsed(!isCollapsed);
          }}
        >
          <strong>{props.header}</strong>
          {collapsible && (
            <Link>
              &nbsp;Show details <CollapsibleTriangle isCollapsed={isCollapsed} />
            </Link>
          )}
        </div>
      )}
      {(!collapsible || !isCollapsed) && props.children}
    </div>
  );
}

const styles = StyleSheet.create({
  logContainer: {
    padding: 14,
    marginBottom: 14,
  },
  header: {
    fontSize: 14,
    marginBottom: 10,
  },
});
